<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <!-- breadcrumbs -->
      <Breadscrumbs
        :links="[
          {
            name: 'FilesDownload',
            to: {
              name: 'FilesDownload'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'FilesDownloadEdit',
              params: {
                id: $route.params.id
              }
            }
          },
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>編輯檔案</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- block -->
    <ProductDownloadCreateEdit></ProductDownloadCreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ProductDownloadCreateEdit from '@/views/G-4__DownloadResources/c/ProductDownloadCreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    ProductDownloadCreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('productDownload', ['download']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getDownload(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('productDownload', {
      getDownload: 'findById',
      saveDownload: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'QACategoryCenter' });
    },
    async saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.download.type) {
            this.errors.push('File Type required.');
          } else if (this.download.type === 2 || this.download.type === 4) {
            if (!this.download.ver) {
              this.errors.push('版本 required.');
            }
          } else if (!this.download.bu_id) {
            this.errors.push('BU required.');
          } else if (!this.download.support_categories_id) {
            this.errors.push('群組 required.');
          } else if (!this.download.type) {
            this.errors.push('File Type required.');
          } else if (!this.download.path) {
            this.errors.push('檔案 required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.saveDownload(this.download).then(() => {
            this.$router.push({ name: 'FilesDownload' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
